<template>
  <div class="ltr">
    <div class="columns box is-shadowless">
      <div class="column is-4 has-text-left is-flex is-align-items-center">
        <label class="label is-flex-grow-1 is-size-5">Choose format :</label>
      </div>
      <div class="column is-flex is-justify-content-center is-align-items-center">
        <label class="radio">
          <input type="radio" value="certification" v-model="tab"/>
          Certification Date
        </label>
      </div>
      <div class="column is-flex is-justify-content-center is-align-items-center">
        <label class="radio">
          <input type="radio" value="seniority" v-model="tab" />
          Seniority
        </label>
      </div>
    </div>
    <div v-if="tab == 'certification'" class=" box is-shadowless">
      <div class="columns">
        <div class="column is-4 has-text-right is-flex is-align-items-center py-0">
          <label class="label is-flex-grow-1">Certification Date :</label>
        </div>
        <div class="column is-flex is-align-items-center is-flex-grow-1 py-0">
          <div class="column is-3">
            <input
              class="input is-info"
              :class="{ 'has-text-danger': certificationDateMonthErrors.error }"
              type="number"
              placeholder="MM"
              v-model.number="certificationDateMonth.value"
            />
          </div>
          <div class="column is-1 is-flex is-align-items-center">
            <label class="label">/</label>
          </div>
          <div class="column">
            <input
              class="input is-info"
              :class="{ 'has-text-danger': certificationDateYearErrors.error }"
              type="number"
              placeholder="YYYY"
              v-model.number="certificationDateYear.value"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4 has-text-right is-flex py-0">
          <p></p>
        </div>
        <div class="column has-text-left py-0 my-0">
          <p v-show="certificationDateYearErrors.error || certificationDateMonthErrors.error" class="column help has-text-danger py-0 my-0">
            {{ certificationDateMonthErrors.message }} {{ certificationDateYearErrors.message }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="tab == 'seniority'" class="box is-shadowless">
      <div class="columns">
        <div class="column is-4 has-text-right is-flex is-align-items-center py-0">
          <label class="label is-flex-grow-1">Seniority :</label>
        </div>
        <div class="column is-flex is-align-items-center is-flex-grow-1 py-0">
          <div class="column is-full">
            <input
              class="input is-info"
              :class="{ 'has-text-danger': seniorityErrors.error }"
              type="number"
              :placeholder="seniorityPlaceholder"
              v-model.number="seniority.value"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4 has-text-right is-flex py-0">
          <p></p>
        </div>
        <div class="column has-text-left py-0 my-0">
          <p v-show="seniorityErrors.error" class="column help has-text-danger py-0 my-0">
            {{ seniorityErrors.message }}
          </p>
        </div>
      </div>
    </div>
    <div class="columns box is-shadowless">
      <div class="column">
        <button
          class="button is-info"
          @click="onSubmitClick"
          :disabled="disableSubmit"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'edit_certification_date_seniority_modal',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      tab: 'certification',
      seniority: {
        value: null,
        dirty: false,
        unwatch: () => {}
      },
      certificationDateMonth: {
        value: null,
        dirty: false,
        unwatch: () => {}
      },
      certificationDateYear: {
        value: null,
        dirty: false,
        unwatch: () => {}
      }
    }
  },
  created () {
    if (this.payload.data.certification_date) {
      const date = new Date(this.payload.data.certification_date)
      this.certificationDateMonth.value = date.getMonth() + 1
      this.certificationDateYear.value = date.getUTCFullYear()
    }
    this.seniority.unwatch = this.$watch('seniority.value', () => {
      this.seniority.dirty = true
      this.seniority.unwatch()
    })
    this.certificationDateMonth.unwatch = this.$watch('certificationDateMonth.value', () => {
      this.certificationDateMonth.dirty = true
      this.certificationDateMonth.unwatch()
    })
    this.certificationDateYear.unwatch = this.$watch('certificationDateYear.value', () => {
      this.certificationDateYear.dirty = true
      this.certificationDateYear.unwatch()
    })
  },
  watch: {
    tab (newValue) {
      switch (newValue) {
        case 'seniority':
          this.certificationDateMonth.value = null
          this.certificationDateYear.value = null
          break
        case 'certification':
          this.seniority.value = null
          break
        default:
          break
      }
    }
  },
  computed: {
    seniorityPlaceholder () {
      return this.payload.data.seniority || 'Seniority Year ...'
    },
    certificationDate () {
      return `${this.certificationDateMonth.value}/${this.certificationDateYear.value}`
    },
    seniorityErrors () {
      if (this.seniority.value > 150) {
        return { error: true, message: 'Can a person live so long ?' }
      }
      if (this.seniority.value < 0) {
        return { error: true, message: 'Are you sure it can be ?' }
      }
      if (this.seniority.dirty && !(this.seniority.value || this.seniority.value === 0)) {
        return { error: true, message: 'Please enter seniority years.' }
      }
      return { error: false, message: '' }
    },
    certificationDateYearErrors () {
      if (this.certificationDateYear.value > 9999) {
        return { error: true, message: 'A long time ago in a galaxy far far away...' }
      }
      if (this.certificationDateYear.value < 0) {
        return { error: true, message: 'In the beginning God created the heavens and the earth...' }
      }
      if (this.certificationDateYear.dirty && !this.certificationDateYear.value) {
        return { error: true, message: 'Please enter year.' }
      }
      return { error: false, message: '' }
    },
    certificationDateMonthErrors () {
      if (this.certificationDateMonth.dirty && !this.certificationDateMonth.value) {
        return { error: true, message: 'Please enter month.' }
      }
      if (this.certificationDateMonth.value === null) {
        return { error: false, message: '' }
      }
      if (this.certificationDateMonth.value <= 0 || this.certificationDateMonth.value > 12) {
        return { error: true, message: 'Not a valid month.' }
      }
      return { error: false, message: '' }
    },
    disableSubmit () {
      switch (this.tab) {
        case 'seniority':
          return this.seniorityErrors.error || !this.seniority.dirty
        case 'certification':
          return this.certificationDateYearErrors.error || this.certificationDateMonthErrors.error || !(this.certificationDateYear.dirty || this.certificationDateMonth.dirty)
        default:
          return false
      }
    }
  },
  methods: {
    onSubmitClick () {
      let certificationDate = this.certificationDate
      if (this.tab == 'seniority') {
        certificationDate = `${this.$moment().subtract(this.seniority.value, 'years').format('MM/YYYY')}`
      }
      this.$network_utils.updateApplicant({ applicant_id: this.payload.data.resource_id, certification_date: certificationDate }).then(() => {
        this.payload.beforeAction(certificationDate)
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
